import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { BI } from './BI';
export class Essentials {
  constructor(options) {
    _defineProperty(this, "bi", void 0);
    this.bi = new BI(options.bi);
  }
}
//# sourceMappingURL=Essentials.js.map